import {SimplePresentation, SimplePresentationRunnerController} from "./SimplePresentationRunner";
import {Possessed} from "../../Possessed";
import {PossessedGameAssets} from "../../PossessedGameAssets";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {gsap} from "gsap"
import {PossessedGameMode} from "../../server/PossessedGameMode";

export class BrokeTheBankPresentation extends SimplePresentation
{

    constructor() {
        super("BrokeTheBank Presentation");
    }

   shouldRun(): boolean {
        return Possessed.model.gameData.brokeTheBank;
   }

   buildTimeline() {
        const tl = this.tl;
        tl.eventCallback("onComplete", ()=>{});
        tl.add(()=> {this.controller.setSkipCallback()});

        tl.add(()=> {
            Possessed.keypadPlugin.setZeroBetSpinCounter(-1);
            Possessed.soundPlayer.fadeOutMusic();
            Possessed.soundPlayer.playLoopingSound("capWinLoop");
            Possessed.keypadPlugin.setWin(Possessed.model.gameData.accumulatedRoundWin,
                                Possessed.model.data.mode != GameMode.NORMAL,
                                          Possessed.model.isWinBelowStake()
            );
        });
        //tl.add(Possessed.xBetView.hide(0.1), "<");
        tl.add(Possessed.transitionScreen.showWinCap());
        tl.add(() => {
            Possessed.soundPlayer.playSound("capWinCountup");
        }, "<")
        tl.add(Possessed.winCounter.countUpWinCap(Possessed.model.data.accumulatedRoundWin, 6.716), "<");
        tl.add(Possessed.transitionScreen.enableButton(() => {this.onButtonClick(this.controller)}), ">");
   }

   private onButtonClick(controller:SimplePresentationRunnerController) {
        const tl = gsap.timeline();
        tl.add(() => {
            Possessed.soundPlayer.stopSound("capWinLoop");
            Possessed.soundPlayer.playSound("capWinEnd");
            Possessed.soundPlayer.restartMusic();
            Possessed.soundPlayer.fadeInMusic(2500);

            if(Possessed.model.isBoostedBet()) {
                Possessed.backgroundElements.setMode("XBET");
                Possessed.reelView.reelCross.updateCross("XBET");
            } else {
                Possessed.backgroundElements.setMode(GameMode.NORMAL);
                Possessed.reelView.reelCross.updateCross(PossessedGameMode.NORMAL);
            }
            Possessed.foregroundElements.setBaseLogo();

        });

        // Remove hotZone dim
        tl.add(Possessed.reelView.reelCross.removeHotzoneDim());

        // Set all symbol to normal state
        tl.add(Possessed.reelView.getAllVisibleSymbols().map(sym => sym.setNormal()), "<");

        tl.add(Possessed.winCounter.hideWinCapCountUp(0.2), "<")
        tl.add(Possessed.transitionScreen.hideIntroOutro(), "<");
        //tl.add(Possessed.xBetView.show());

        tl.add(() => {controller.finish()});
   }
}